import { CSSProperties, useId, useState } from 'react';
import { LiveDraft } from '@utils/editors/live-transcript-state.ts';

type Props = {
  label: string;
  rows: LiveDraft[];
  selectedId: string;
  disabled: boolean;
  style: CSSProperties;
  select: (id: string) => void;
};

export const LiveRangeInput = ({
  label,
  rows,
  selectedId,
  disabled,
  style,
  select
}: Props) => {
  const description = useId();
  const [value, setValue] = useState(() =>
    String(
      rows.find(row => row.segment.segment_id === selectedId)?.segment
        .sequence ?? ''
    )
  );
  const selected = rows.find(row => row.segment.sequence === Number(value));
  return (
    <label className="flex flex-col gap-1 text-sm">
      {label}
      <input
        type="number"
        inputMode="numeric"
        min={rows[0]?.segment.sequence ?? 1}
        max={rows.at(-1)?.segment.sequence ?? 1}
        step={1}
        aria-label={label}
        aria-describedby={description}
        value={value}
        disabled={disabled}
        className="rounded-lg border p-2 min-w-0"
        style={style}
        onChange={event => {
          const next = event.target.value;
          setValue(next);
          const row = rows.find(item => item.segment.sequence === Number(next));
          select(next && row ? row.segment.segment_id : '');
        }}
      />
      <span id={description} className="text-xs tabular-nums">
        {selected &&
          `#${selected.segment.sequence} · ${new Date(selected.segment.utterance.start ?? 0).toISOString().slice(11, 19)}`}
      </span>
    </label>
  );
};
